import { html, LitElement, unsafeCSS } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { repeat } from 'lit/directives/repeat.js';
import { SubHelper } from '../../_ui-core_/base/package/patterns/package/store';
import { I18n } from '../../_ui-core_/base/package/services/package/i18n/i18n.de';
import { dispatchCustomEvent } from '../../_ui-core_/base/package/util/event';
import { tick } from '../../_ui-core_/base/package/util/render';
import App from '../../app';
import type { ClubThousand } from '../../app/package/base/cms/package/cms-domain';
import { HeaderOptionsEventName } from '../../app/package/base/router/router-types/sidebar-types';
import { LoginStatus } from '../../app/package/base/service/login/login-domain';
import { TrackingEventSource } from '../../app/package/base/service/tracking/tracking-service';
import style from './styles.css?inline';
import '../../_ui-core_/components/ui-club-1000-card/ui-club-1000-card';

const CName = 'club-thousands-page';

@customElement(CName)
export class ClubThousandsPage extends LitElement {
  static readonly styles = unsafeCSS(style);

  @state() private _loggedIn = false;
  @state() private _clubThousandItems: ClubThousand[] | undefined;

  private readonly _subHelper = new SubHelper();
  private _renderTaskId: number | null = null;

  async connectedCallback() {
    super.connectedCallback();

    this._renderTaskId = window.$app.renderService.addTask('club-1000');
    this._loggedIn = (await App.instance.login.getFinalLoginStatus()) === LoginStatus.LOGGED_IN;

    this._subHelper.addSub(
      App.instance.content.getClubThousandItems(),
      (_) => this._updateClubThousand(_ || undefined),
      true,
    );
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this._subHelper.unsubscribeAll();
  }

  protected firstUpdated() {
    this._updateHeader();
  }

  render() {
    return html`
      <main class="page-content">
        ${this._clubThousandItems?.length ? this._renderClubThousandItems() : this._renderNoItems()}
      </main>
    `;
  }

  private _renderClubThousandItems() {
    const wrapperClass = `club-1000-wrapper ${this._clubThousandItems?.length === 1 ? 'club-1000-wrapper--one-item' : ''}`;
    return html`
      <div class=${wrapperClass}>
        ${repeat(
          this._clubThousandItems!,
          (clubThousand, index) =>
            html`
              <ui-club-1000-card
                .index=${index}
                .loggedIn=${this._loggedIn}
                .clubThousand=${clubThousand}
              ></ui-club-1000-card>
            `,
        )}
      </div>
    `;
  }

  private _renderNoItems() {
    return html`<div class="center-panel">${window.$app.$t.get(I18n.clubThousandItems.page.noClubThousand)}</div>`;
  }

  private _updateClubThousand(clubThousandItems: ClubThousand[] | undefined) {
    this._clubThousandItems = clubThousandItems;
    tick().then(() => {
      if (this._renderTaskId !== null) {
        this._renderTaskId = window.$app.renderService.removeTask(this._renderTaskId);
      }
    });
  }

  private _updateHeader() {
    dispatchCustomEvent(this, HeaderOptionsEventName, {
      title: 'Club 1000x',
      isGoBackShown: true,
      trackingSource: TrackingEventSource.CLUB1000X,
    });
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: ClubThousandsPage;
  }
}
